export default __webpack_public_path__ + "static/media/color-noticeable.3ab4fc1b.webp";